import classNames from "classnames";
import React, { FunctionComponent, memo } from "react";

import { ITextProps as IEworkitTextProps, Text as EworkitText, TStyleTextColor } from "@/eworkitComponents";
import { buildTextColorVariantClassNames, TColorVariant } from "@/style/colorVariants";

export interface ITextProps extends Omit<IEworkitTextProps, "color"> {
  color?: TColorVariant;
}

export const Text: FunctionComponent<ITextProps> = memo(props => {
  const colorVariant = props.color || "inherit";
  const eworkitColor = colorVariant as TStyleTextColor;

  return (
    <EworkitText
      {...props}
      className={classNames(props.className, buildTextColorVariantClassNames(colorVariant))}
      color={eworkitColor}
    />
  );
});
